import React, { Component } from "react";
import { Row, Col, Button, Form, Modal, Image } from "react-bootstrap";
import {
  ListarTipoEstabelecimento,
  CadastrarTipoEstabelecimento,
  EditarTipoEstabelecimento,
  DeletarTipoEstabelecimento,
} from "../../providers/TiposEstabelecimentoProvider";
import { api_url_tipos_image } from "../../providers/api";
import TBLTiposEstabelecimento from "../../components/TBLTiposEstabelecimento";
import { toast } from "react-toastify";
import Select from "react-select";

export default class TiposEstabelecimento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: {
        nome: "",
        imagem: null,
        categoriaNegocio: null,
      },
      tipos: [],
      tipoSelecionado: null,
      categoriasNegocio: [
        { label: "B2C", value: "B2C" },
        { label: "B2B", value: "B2B" },
      ],
      categoriaNegocioSelecionada: null,
      showModalTipo: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarTipo: false,

      nome: "",
      porcentagemTaxaServico: null,
      imagem: null,

      mensagemAlert: "",
      variantAlert: "",
    };
    this.fileInput = null;
  }

  fileChangedHandler = (event) => {
    this.setState({ imagem: event.target.files[0] });
  };

  handleCloseModalTipo = () => {
    this.setState({ showModalTipo: false });
    this.limparForm();
  };

  handleShowModalTipo = () => {
    this.setState({ showModalTipo: true });
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else if (variant === "error") {
      toast.error(mensagem);
    } else {
      toast.info(mensagem);
    }
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = () => {
    this.setState({ showModalAlert: true });
  };

  cadastrarTipoEstabelecimento = async () => {
    let form = new FormData();
    let { nome, imagem, categoriaNegocioSelecionada, porcentagemTaxaServico } =
      this.state;
    if (this.validarForm()) {
      form.append("nome", nome);
      form.append("imagem", imagem);
      form.append("categoria", categoriaNegocioSelecionada?.value);
      form.append("porcentagem_taxa_servico", porcentagemTaxaServico || 0);
      try {
        const response = await CadastrarTipoEstabelecimento(form);
        if (response) {
          const list = await ListarTipoEstabelecimento();
          this.setState({ tipos: list });
          this.limparForm();
          this.handleShowAlert("Tipo cadastrado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao cadastrar Tipo", "error");
      }
    } else {
      this.setState({
        errorCadastro: "Informações obrigatórias faltando",
      });
    }
  };

  editarTipoEstabelecimento = async () => {
    let form = new FormData();
    let formJson = {};
    let { nome, imagem, categoriaNegocioSelecionada, porcentagemTaxaServico } =
      this.state;
    if (this.validarForm()) {
      if (imagem) {
        form.append("nome", nome);
        form.append("categoria", categoriaNegocioSelecionada?.value);
        form.append("porcentagem_taxa_servico", porcentagemTaxaServico || 0);
        form.append("imagem", imagem);
      } else {
        formJson = {
          nome,
          categoria: categoriaNegocioSelecionada?.value,
          porcentagem_taxa_servico: porcentagemTaxaServico || 0,
        };
      }
      try {
        let response;
        if (imagem) {
          response = await EditarTipoEstabelecimento(
            form,
            this.state.tipoSelecionado._id,
          );
        } else {
          response = await EditarTipoEstabelecimento(
            formJson,
            this.state.tipoSelecionado._id,
          );
        }
        if (response) {
          const list = await ListarTipoEstabelecimento();
          this.setState({ tipos: list });
          this.limparForm();
          this.handleShowAlert("Tipo editado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert("Erro ao editar Tipo", "error");
      }
    } else {
      this.setState({ errorCadastro: "Informações obrigatórias faltando" });
    }
  };

  deletarTipoEstabelecimento = async () => {
    try {
      const response = await DeletarTipoEstabelecimento(this.state.tipoSelecionado._id);
      if (response) {
        const list = await ListarTipoEstabelecimento();
        this.setState({ tipos: list });
        this.limparForm();
        this.handleShowAlert("Tipo deletado com sucesso", "secondary");
      }
    } catch (error) {
      this.handleShowAlert("Erro ao deletar Tipo", "error");
    }
  };

  async componentDidMount() {
    const response = await ListarTipoEstabelecimento();
    this.setState({ tipos: response });
  }

  validarForm = () => {
    let isValid = true;
    let error = this.state.error;
    if (this.state.nome === "" || this.state.nome === null) {
      error.nome = "Campo obrigatório";
      isValid = false;
    } else {
      error.nome = "";
    }
    if (!this.state.categoriaNegocioSelecionada?.value) {
      error.categoriaNegocio = "Categoria obrigatória";
      isValid = false;
    } else {
      error.categoriaNegocio = "";
    }
    if (this.state.imagem === null && !this.state.tipoSelecionado) {
      error.imagem = "Imagem obrigatório";
      isValid = false;
    } else {
      error.imagem = "";
    }
    this.setState({ error });
    return isValid;
  };

  limparForm = () => {
    this.setState({
      error: {
        nome: "",
        imagem: null,
        categoriaNegocio: null,
      },
      tipoSelecionado: null,
      categoriaNegocioSelecionada: null,
      showModalTipo: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarTipo: false,

      nome: "",
      porcentagemTaxaServico: null,
      imagem: null,

      mensagemAlert: "",
      variantAlert: "",
    });
    this.fileInput ? (this.fileInput.value = "") : (this.fileInput = null);
  };

  preencherFormEdit = (dados) => {
    this.setState({
      nome: dados.nome,
      modoEditarTipo: true,
      tipoSelecionado: dados,
      categoriaNegocioSelecionada: {
        label: dados.categoria || "B2C",
        value: dados.categoria || "B2C",
      },
      porcentagemTaxaServico: dados.porcentagem_taxa_servico || 0,
    });
    this.handleShowModalTipo();
  };

  receberDadosTabela = (tipo, dados) => {
    if (tipo === "editar") {
      this.preencherFormEdit(dados);
    } else if (tipo === "deletar") {
      this.setState({ tipoSelecionado: dados });
      this.handleShowModalAlert();
    } else {
      return;
    }
  };

  render() {
    return (
      <div style={{ margin: 10, marginLeft: 50, marginRight: 50 }}>
        <br></br>
        <Row>
          <Col md={9}>
            <h3>Tipos de Estabelecimento</h3>
          </Col>
          <Col>
            <Button
              onClick={() => {
                this.handleShowModalTipo();
              }}
            >
              Cadastrar tipo
            </Button>
          </Col>
        </Row>
        <br></br>

        <div>
          <TBLTiposEstabelecimento
            data={this.state.tipos}
            numRows={10}
            dataCallback={this.receberDadosTabela}
          ></TBLTiposEstabelecimento>
        </div>

        <Modal
          size="xl"
          show={this.state.showModalTipo}
          onHide={this.handleCloseModalTipo}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.modoEditarTipo
                ? "Editar Tipo de Estabelecimento"
                : "Cadastrar Tipo de Estabelecimento"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.modoEditarTipo ? (
              <div style={{ width: "100%", textAlign: "center", marginBottom: 20 }}>
                <Image
                  rounded
                  style={{ width: 60, height: 60 }}
                  src={api_url_tipos_image + this.state.tipoSelecionado.foto_tipo}
                ></Image>
              </div>
            ) : null}
            {this.state.errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
              </div>
            ) : null}
            <Form>
              <Form.Group>
                <Form.Label>Categoria de negócio*</Form.Label>
                <Select
                  value={this.state.categoriaNegocioSelecionada}
                  onChange={(opt) => {
                    this.setState({
                      categoriaNegocioSelecionada: opt,
                    });
                  }}
                  options={this.state.categoriasNegocio}
                  placeholder="Categoria"
                />
                {this.state.error.categoriaNegocio ? (
                  <div>
                    <p style={{ color: "red" }}>{this.state.error.categoriaNegocio}</p>
                  </div>
                ) : null}
              </Form.Group>
              <Form.Group>
                <Form.Label>Nome do tipo *</Form.Label>
                <Form.Control
                  value={this.state.nome}
                  type="text"
                  placeholder="Nome"
                  onChange={(e) => {
                    this.setState({ nome: e.target.value });
                  }}
                />
                {this.state.error.nome ? (
                  <div>
                    <p style={{ color: "red" }}>{this.state.error.nome}</p>
                  </div>
                ) : null}
              </Form.Group>
              <Form.Group>
                <Form.Label>Percentual para calculo da taxa de serviço</Form.Label>
                <Form.Control
                  value={this.state.porcentagemTaxaServico}
                  type="number"
                  min={0}
                  max={1}
                  placeholder="0,00"
                  onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    if (value < 0 || value > 1) return;
                    this.setState({ porcentagemTaxaServico: value });
                  }}
                />
                <Form.Text>Ex: 0,2 equivale a 20%</Form.Text>
              </Form.Group>

              <Form.Group>
                <Form.Label>Imagem *</Form.Label>
                <input
                  style={{ padding: 3 }}
                  className={"form-control"}
                  type="file"
                  accept="image/x-png,image/gif,image/jpeg"
                  ref={(ref) => (this.fileInput = ref)}
                  onChange={this.fileChangedHandler}
                ></input>
                {this.state.error.imagem ? (
                  <div>
                    <p style={{ color: "red" }}>{this.state.error.imagem}</p>
                  </div>
                ) : null}
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalTipo();
              }}
            >
              Fechar
            </Button>
            {this.state.modoEditarTipo ? (
              <Button
                variant="primary"
                onClick={() => {
                  this.editarTipoEstabelecimento();
                }}
              >
                {"Editar"}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.cadastrarTipoEstabelecimento();
                }}
              >
                {"Cadastrar"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.showModalAlert}
          onHide={this.handleCloseModalAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Deseja realmente excluir o tipo?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.deletarTipoEstabelecimento(this.state.tipoSelecionado);
              }}
            >
              Sim
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
